import { queryOptions } from '@tanstack/react-query'
import type { TicketCardRow, TicketChangesPage } from './easeedesk'

/**
 * Tichetul vazut de CLIENT, prin linkul din email -
 * `Easeedesk::customer_ticket_details`.
 *
 * NU trece prin `apiGet`. Capatul e sub `/api/v2/public/`, se deschide fara
 * sesiune, si tocmai de aceea nu trebuie sa aiba nimic din purtarea celuilalt
 * drum: la 401, `apiGet` cere un token nou si apoi TRIMITE OMUL LA ECRANUL DE
 * INTRARE. Clientul care a apasat linkul din email n-are cont in portal - ar
 * fi ajuns la o pagina de autentificare in loc de tichetul lui, si n-ar fi
 * aflat niciodata de ce.
 *
 * Aici un raspuns care nu e 200 inseamna un singur lucru, si e cel din portal:
 * linkul nu mai e bun.
 */

export interface CustomerTicketAttachment {
  name: string
  size: number
  image: boolean
  thumbnail: string
}

export interface CustomerTicketPageData {
  ticket: number
  row: TicketCardRow
  /** Descrierea, HTML, asa cum a fost scrisa. Goala = "No description available". */
  description: string
  attachments: CustomerTicketAttachment[]
  history: TicketChangesPage | null
}

/** Linkul nu deschide nimic: jeton stricat, vechi, sau tichet care nu mai e. */
export class TicketLinkGone extends Error {
  constructor() {
    super('This ticket link is no longer valid.')
    this.name = 'TicketLinkGone'
  }
}

export async function fetchCustomerTicket(token: string): Promise<CustomerTicketPageData> {
  const response = await fetch(`/api/v2/public/easeedesk/ticket/${encodeURIComponent(token)}`, {
    headers: { Accept: 'application/json' },
  })

  if (!response.ok) throw new TicketLinkGone()

  return (await response.json()) as CustomerTicketPageData
}

export function customerTicketQuery(token: string) {
  return queryOptions({
    queryKey: ['easeedesk', 'customer-ticket', token],
    queryFn: () => fetchCustomerTicket(token),
    retry: false,
  })
}

/**
 * Textul unui comentariu din jurnalul paginii - `easeedesk/getTicketCommentDetailsCustomer`
 * (iframe-ul din `changes_customer.php`). Un comentariu privat vine cu textul
 * portalului in loc de continut.
 */
export async function fetchCustomerComment(token: string, comment: number): Promise<{ id: number; private: boolean; comment: string }> {
  const response = await fetch(`/api/v2/public/easeedesk/ticket/${encodeURIComponent(token)}/comments/${comment}`, {
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) throw new Error('Comment not found.')

  return (await response.json()) as { id: number; private: boolean; comment: string }
}
